/**
 * Compatibility entry point for consumers that need the unmodified react-popper API while moving
 * dependency ownership to @atlaskit/popper.
 */
export { Manager, Popper, Reference, usePopper } from 'react-popper';
export type {
	Modifier,
	PopperArrowProps,
	PopperChildrenProps,
	PopperProps,
	StrictModifier,
} from 'react-popper';
